"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MfaStatusResponseSchema", {
    enumerable: true,
    get: function() {
        return MfaStatusResponseSchema;
    }
});
const _zod = require("zod");
const MfaStatusResponseSchema = _zod.z.object({
    totpEnrolled: _zod.z.boolean(),
    recoveryCodesRemaining: _zod.z.number().int().nonnegative()
}).strict();
